
import React, { useEffect, useState } from "react";
import Accordion from "./common/Accordion";
import InputFieldControl from "./common/InputFieldControl";
import { storeLead } from "./actions/StoreLeadAction";
import toast from "react-hot-toast";
import { maskEmail } from "../../../common/Utility";

const AboutThisContactForm = ({
  industryList,
  productsList,
  customerDetails,
  editPermissions,
  refreshCustomerDetails = () => {},
}) => {
  const [ConfirmationModalOpen, setConfirmationModalOpen] = useState(false);

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone_number: "",
    company_name: "",
    industry: "",
    create_date: null,
    last_activity_date: null,
    associated_products: [],
    lead_source: "",
    lead_type: "",
    sql: "0",
    // lead_score: "",
    lead_status: "",
    // action_taken: "",
  });

  useEffect(() => {
    if (customerDetails) {
      fetchFromData();
    }
  }, [customerDetails]);

  const fetchFromData = () => {
    setFormData({
      name: customerDetails.name || "",
      email: maskEmail(customerDetails.email || "", 4, "email"),
      phone_number: maskEmail(customerDetails.phone_number || "", 4, "phone_number"),
      company_name: customerDetails.company_name || "",
      industry: customerDetails.industry || "",
      created_date: customerDetails.created_date
        ? new Date(customerDetails.created_date)
        : null,
      last_activity_date: customerDetails.last_activity_date
        ? new Date(customerDetails.last_activity_date)
        : null,
      associated_products: customerDetails.associated_products || [],
      lead_source: customerDetails.lead_source || "",
      lead_type: customerDetails.lead_type || "",
      sql: customerDetails.sql || "0",
      // lead_score: parseInt(customerDetails.lead_score) || "0",
      lead_status: customerDetails.lead_status || "",
      // action_taken: customerDetails.action_taken || "",
      // close_reason: customerDetails.close_reason || "",
      // close_reason_details: customerDetails.close_reason_details || "",
    });
  };

  const handleInputChange = (valueFor, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [valueFor]: value,
    }));
  };

  const onEditClick = () => {
    setIsEditing(true);
  };

  const handleContactInfoSave = async () => {
    setConfirmationModalOpen(false);
    setIsLoading(true);

    if (!handleValidation()) {
      setIsLoading(false);
      return;
    }

    const response = await storeLead(formData);

    if (response.success) {
      toast.success("Lead Updated successfully!");
      await refreshCustomerDetails();
    } else {
      toast.error(
        "An error occurred while processing your request. Please try again!"
      );
    }

    setIsEditing(false);
    setIsLoading(false);
  };

  const handleCancelEdit = () => {
    fetchFromData();
    setIsEditing(false);
  };

  const handleValidation = () => {
    setErrors({});

    const errors = {};
    let isValid = true;

    if (!formData.name || formData.name.trim() === "") {
      errors.name = "Name is required";
      isValid = false;
    }

    if (!formData.email || formData.email.trim() === "") {
      errors.email = "Email is required";
      isValid = false;
    }

    if (!formData.company_name || formData.company_name.trim() === "") {
      errors.company_name = "Company is required";
      isValid = false;
    }

    if (!formData.lead_source || formData.lead_source.trim() === "") {
      errors.lead_source = "Lead Source is required";
      isValid = false;
    }

    setErrors(errors);
    return isValid;
  };

  const ActionButton = () => {
    if (isLoading) {
      return (
        <button className="editprimary-btn editsecondry-btn" disabled>
          Loading...
        </button>
      );
    }

    return (
      <React.Fragment>
        <button
          className="editprimary-btn editsecondry-btn"
          onClick={(e) => {
            e.stopPropagation();
            if (isEditing) {
              // onSaveClick();
              handleContactInfoSave();
            } else {
              onEditClick();
            }
          }}
        >
          {!isEditing && (
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
              >
                <g clip-path="url(#clip0_501_8376)">
                  <path
                    d="M8.5 1.5C8.63132 1.36868 8.78722 1.26451 8.9588 1.19344C9.13038 1.12236 9.31428 1.08578 9.5 1.08578C9.68572 1.08578 9.86962 1.12236 10.0412 1.19344C10.2128 1.26451 10.3687 1.36868 10.5 1.5C10.6313 1.63132 10.7355 1.78722 10.8066 1.9588C10.8776 2.13038 10.9142 2.31428 10.9142 2.5C10.9142 2.68572 10.8776 2.86961 10.8066 3.04119C10.7355 3.21277 10.6313 3.36868 10.5 3.5L3.75 10.25L1 11L1.75 8.25L8.5 1.5Z"
                    stroke="#006EFA"
                    stroke-width="1.33"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_501_8376">
                    <rect width="12" height="12" fill="white"></rect>
                  </clipPath>
                </defs>
              </svg>
            </span>
          )}
          {isEditing ? "Save" : "Edit"}
        </button>
        {isEditing && (
          <button
            className="editprimary-btn editsecondry-btn"
            onClick={(e) => {
              e.stopPropagation();
              handleCancelEdit();
            }}
          >
            {"Cancel"}
          </button>
        )}
      </React.Fragment>
    );
  };

  return (
    <Accordion
      header="About this contact"
      targetID="customerDetailsForm"
      actionButton={editPermissions && <ActionButton />}
      overrideOpenState={isEditing ? true : null}
    >
      <div className="form-customer-details">
        <div className="customer-info">
          <InputFieldControl
            fieldName="name"
            label="Full Name"
            type={"text"}
            isEditing={isEditing}
            formData={formData}
            handleInputChange={handleInputChange}
            isLoading={isLoading}
            required={true}
            error={errors.name}
          />
          <InputFieldControl
            fieldName="email"
            label="Email"
            type={"email"}
            isEditing={false} // Email is not editable
            formData={formData}
            handleInputChange={handleInputChange}
            isLoading={isLoading}
            required={true}
            error={errors.email}
          />
          <InputFieldControl
            fieldName="phone_number"
            label="Phone Number"
            type={"tel"}
            isEditing={isEditing}
            formData={formData}
            handleInputChange={handleInputChange}
            isLoading={isLoading}
            error={errors.phone_number}
          />
          <InputFieldControl
            fieldName="company_name"
            label="Company"
            type={"select"}
            isEditing={isEditing}
            formData={formData}
            handleInputChange={handleInputChange}
            isLoading={isLoading}
            required={true}
            error={errors.company_name}
          />
          <InputFieldControl
            fieldName="account_type"
            label="Account Type"
            type={"text"}
            isEditing={false} // Email is not editable
            formData={formData}
            handleInputChange={handleInputChange}
            isLoading={isLoading}
            error={errors.account_type}
            // Make first letter uppercase
            defaultValue={
              customerDetails.account_type
                ? customerDetails.account_type.charAt(0).toUpperCase() +
                customerDetails.account_type.slice(1)
                : ""
            }
          />
          <InputFieldControl
            fieldName="industry"
            label="Industry"
            type={"select"}
            isEditing={isEditing}
            formData={formData}
            handleInputChange={handleInputChange}
            data={industryList}
            multiSelect={true}
            isLoading={isLoading}
            error={errors.industry}
          />
          <InputFieldControl
            fieldName="associated_products"
            label="Associated Products"
            type={"select"}
            isEditing={isEditing}
            formData={formData}
            handleInputChange={handleInputChange}
            data={productsList}
            multiSelect={true}
            isLoading={isLoading}
            error={errors.associated_products}
          />
          <InputFieldControl
            fieldName="lead_source"
            label="Lead Source"
            type={"select"}
            isEditing={isEditing}
            formData={formData}
            handleInputChange={handleInputChange}
            data={[
              { value: "Free Trial", id: "Free Trial" },
              { value: "Extranet Chat", id: "Extranet Chat" },
              { value: "Migration Request", id: "Migration Request" },
              { value: "Live Chat", id: "Live Chat" },
              { value: "Muvi Webinars", id: "Muvi Webinars" },
              { value: "Contact Us", id: "Contact Us" },
              { value: "Ask Sales", id: "Ask Sales" },
              { value: "PDF Download", id: "PDF Download" },
              { value: "Outbound", id: "Outbound" },
              { value: "Extranet", id: "Extranet" },
              { value: "Muvi Classic Cms Chat", id: "Muvi Classic Cms Chat" },
              { value: "Live Demo Request", id: "Live Demo Request" },
              { value: "Partner Request", id: "Partner Request" },
              { value: "Reseller Application", id: "Reseller Application" },
              { value: "Landing Chat", id: "Landing Chat" },
              { value: "Conferences/Events", id: "Conferences/Events" },
              { value: "Social Media (LinkedIn, Twitter, etc.)", id: "Social Media (LinkedIn, Twitter, etc.)" },
              { value: "Inside Sales", id: "Inside Sales" },
              { value: "Muvi Ultimate", id: "Muvi Ultimate" },
              { value: "Tagged with Anchor Lead", id: "Tagged with Anchor Lead" },
              { value: "Outbound Partnership Request", id: "Outbound Partnership Request" },
              { value: "Inbound Partnership Request", id: "Inbound Partnership Request" },
              { value: "Sanjh Contacts", id: "Sanjh Contacts" },
              { value: "Alie Contacts", id: "Alie Contacts" },
              { value: "Individual", id: "Individual" },
              { value: "Partner / Reseller / Affiliate / Referral", id: "Partner / Reseller / Affiliate / Referral" },
              { value: "SMB", id: "SMB" },
              { value: "Enterprise", id: "Enterprise" },
              { value: "Alie Newsletter Subscriptions", id: "Alie Newsletter Subscriptions" },
              { value: "Extranet Forms", id: "Extranet Forms" },
              { value: "Template Request", id: "Template Request" },
              { value: "RFP Download", id: "RFP Download" }
            ]}

            isLoading={isLoading}
            required={true}
            error={errors.lead_source}
          />
        </div>
      </div>

    </Accordion>
  );
};

export default AboutThisContactForm;



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/AboutThisContactForm.js